module.exports = __webpack_public_path__ + "static/homeSmall-f1aa16d14c50f1e3d5daf4ca86fdc689.jpg";